<template>
  <b-modal
    :id="id"
    :cancel-title="$t('Cancel')"
    :ok-title="$t('Delete')"
    :title="$t('Delete') + ' ' + theArticle  + $t(itemSingularName)"
    cancel-variant="outline-primary"
    ok-variant="danger"
    centered
    @ok="handleOk">
    <div v-if="selectedItem !== null" class="mb-2">
      {{ $t('Delete') }} {{ theArticle }}{{ $t(itemSingularName) }} {{ itemToString }} ?
    </div>
    <div v-if="selectedItem !== null && warningMessage !== null" class="mb-4">
      {{ $t(warningMessage) }}
    </div>
  </b-modal>
</template>

<script>

import api from '../../services/api'

export default {

  name: 'ItemDeleteModal',

  props: {
    selectedItem: Object,
    selectedItemSpecialString: {
      type: String,
      default: null
    },
    controllerName: String,
    itemSingularName: String,
    itemSingularNameUpp: String,
    isFeminine: {
      type: Boolean,
      default: false
    },
    beginsWithVoyel: {
      type: Boolean,
      default: false
    },
    warningMessage: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: "item-delete-modal"
    }
  },

  emits: ['didDeleteItem'],

  methods: {

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {
      let successToastMessage = this.$i18n.t(this.itemSingularNameUpp) + this.itemToString + ' ' + this.$i18n.t(this.isFeminine ? 'f.deleted' : 'deleted')

      api
        .delete(`/${this.controllerName}/${this.selectedItem.id}`)
        .then(response => {
          this.$emit('didDeleteItem')
          this.hideModal()
          this.$nextTick(() => {
            this.successToast(successToastMessage)
          })
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.$bvToast.toast(error.response.data.message, {
              autoHideDelay: 4000,
              toaster: 'b-toaster-bottom-right',
              variant: "danger",
              solid: true,
            })
          }
        })
    },

    hideModal() {
      this.$bvModal.hide(this.id)
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }
  },

  computed: {

    itemToString() {
      return this.selectedItemSpecialString ? this.selectedItemSpecialString : " '" + this.selectedItem.tostring + "' "
    },

    theArticle() {
      return this.$i18n.t(this.beginsWithVoyel ? 'l.i' : (this.isFeminine ? 'l.e' : 'l')) + (this.beginsWithVoyel ? '' : ' ')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/b122/ItemDeleteModal.vue